// Added by Sejune Oh on 2020-02-18
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { FC } from 'react'
import {
  InputBase as MaterialInputBase,
  InputBaseProps as MaterialInputBaseProps,
} from '@material-ui/core'

// Common props
interface InputBaseBaseProps {}

// Props for InputBase
export type InputBaseProps = Partial<MaterialInputBaseProps> & InputBaseBaseProps
export const InputBase: FC<InputBaseProps> = ({ ...props }) => {
  return <MaterialInputBase {...props} />
}
